<template>
  <main class="container-fluid pb_50 mb_50 addPayMent" v-if="addPaymentScope">
    <section class="segment pt_12">
      <!-- 要被保人資訊 -->
      <InsuredInfo mode="edit" />
      <!-- 建議明細 -->
      <template>
        <div class="mt-4">
          ※提醒您，繳交超額保險費或變更基本保額時，仍需符合商品相關規範。<br />
          ※繳交超額保險費或變更基本保額是假設情況，實際須保戶辦理才會生效。
        </div>
      </template>
      <h4 class="text-green mt_15 mb_10">新增繳費方式</h4>
      <div class="mt_5 text-red fz_13">
        調整基本保額最高可至{{
          this.PRODUCT_FEATURE_DATA.pol_period * 1 - 1
        }}歲。
      </div>
      <!-- 調整基本保額: -->
      <div class="mt_10">
        <h5>調整基本保額:</h5>
        <div
          class="row mt_10 ml_30"
          v-for="(item, index) in addPaymentScope.adjAmtFlexible"
          :key="index"
        >
          <div class="col-2">
            <div class="d-flex align-items-center">
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'start_age')"
                v-model.trim="item.start_age"
                :class="{
                  'is-invalid':
                   showError &&
                    (!item.start_age ||
                      item.start_age * 1 <
                        MfEditing.insured.insured_age * 1 + 1 ||
                      item.start_age * 1 >
                        PRODUCT_FEATURE_DATA.pol_period * 1 - 1 ||
                      (index - 1 > -1 &&
                        addPaymentScope.adjAmtFlexible[index - 1].start_age *
                          1 >=
                          addPaymentScope.adjAmtFlexible[index].start_age * 1)),
                }"
              />
              <strong class="ml_5">歲</strong>
            </div>
          </div>
          <div class="col-4">
            <div class="d-flex mr_1 align-items-center">
              <strong class="mr_5">保額</strong>
              <input
                ype="tel"
                class="form-control mr_2 ml_5"
                style="width: 7rem"
                :class="{
                  'is-invalid':
                  (item.premium != '' &&
                    (adj_amt_limit &&
                        (item.premium * 1 < adj_amt_limit.amt_floor * 1 ||
                          item.premium * 1 > adj_amt_limit.amt_ceil * 1))) || 
                          errors.has(`adjAmtFlexible_${index}`) ,
                }"
                :data-vv-name="`adjAmtFlexible_${index}`"
                v-validate="{
                  required: true,
                  adjAmtFlexible: { 
                    floor: adj_amt_limit.amt_floor,
                    ceil: adj_amt_limit.amt_ceil
                  }
                }"
                @input="numberHandler(item, 'premium', $event)"
                :value="item.premium | formatMethods"
                :placeholder="
                  adj_amt_limit
                    ? `${formatMethods(
                        adj_amt_limit.amt_floor
                      )}~${formatMethods(adj_amt_limit.amt_ceil)}`
                    : ''
                "
              />
              <span class="ml_5">
                {{
                  unit_curr(
                    PRODUCT_FEATURE_DATA.amt_unit,
                    PRODUCT_FEATURE_DATA.curr
                  )
                }}
              </span>
              <div
                class="btn btn-default btn-sm px_2 pt_2 ml_5"
                @click="deletRange('adjAmtFlexible', index)"
              >
                <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt_10">
          <div
            class="btn btn-default add__button"
            @click="addRange('adjAmtFlexible')"
          >
            <i class="icon-add_new text-orange i-20 mr_5"></i>
            <div>增加一筆</div>
          </div>
        </div>
      </div>
      <div class="mf_divid mt_15"></div>
      <div class="mt_5 text-red fz_13">
        超額保費可繳納至{{ nowProduct.pol_endage }}歲。
      </div>
      <!-- 定期超額保費: -->
      <div class="mt_10">
        <h5>定期超額保費:</h5>
        <div
          class="row mt_10"
          v-for="(item, index) in addPaymentScope.regularFlexiblePrem"
          :key="index"
        >
          <div class="col-3">
            <div class="d-flex align-items-center">
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'start_age')"
                v-model.trim="item.start_age"
                :class="{
                  'is-invalid':
                    showError &&
                    (!item.start_age ||
                      item.start_age * 1 < MfEditing.insured.insured_age * 1 ||
                      (index - 1 > -1 &&
                        addPaymentScope.regularFlexiblePrem[index].start_age *
                          1 <=
                          addPaymentScope.regularFlexiblePrem[index - 1]
                            .end_age *
                            1)),
                }"
              />
              <strong class="mr_2">歲 ~ </strong>
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2 ml_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'end_age')"
                v-model.trim="item.end_age"
                :class="{
                  'is-invalid':
                    showError &&
                    (!item.end_age ||
                      item.end_age * 1 > nowProduct.pol_endage * 1 ||
                      item.end_age * 1 < item.start_age * 1),
                }"
              />
              <strong>歲:</strong>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex mr_10 align-items-center">
              <strong>每月繳費:</strong>
              <input
                ype="tel"
                class="form-control mr_2 ml_2"
                style="width: 7rem"
                :class="{
                  'is-invalid': errors.has(`regularFlexiblePrem_${index}`),
                }"
                :data-vv-name="`regularFlexiblePrem_${index}`"
                v-validate="`required|regularFlexiblePrem`"
                @input="numberHandler(item, 'premium', $event)"
                @blur="numberHandler(item, 'premium', $event)"
                :value="item.premium | formatMethods"
              />元
              <div class="text-red fz_13 ml_5 mr_6" style="width: 14.5rem">
                {{
                  `最低${formatMethods(
                    PRODUCT_FEATURE_DATA.untm_amt_lmt
                  )}${currTranser(
                    PRODUCT_FEATURE_DATA.curr,
                    true
                  )}，且需以${formatMethods(
                    PRODUCT_FEATURE_DATA.face_prem_incr_unit
                  )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
                }}
              </div>
              <div
                class="btn btn-default btn-sm px_2 pt_2"
                @click="deletRange('regularFlexiblePrem', index)"
              >
                <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt_10">
          <div
            class="btn btn-default add__button"
            @click="addRange('regularFlexiblePrem')"
          >
            <i class="icon-add_new text-orange i-20 mr_5"></i>
            <div>增加一筆</div>
          </div>
        </div>
      </div>
      <div class="mf_divid mt_15"></div>
      <!-- 超額保費: -->
      <div class="mt_10">
        <h5>超額保費:</h5>
        <div
          class="row mt_10"
          v-for="(item, index) in addPaymentScope.flexiblePrem"
          :key="index"
        >
          <div class="col-3">
            <div class="d-flex align-items-center">
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'start_age')"
                v-model.trim="item.start_age"
                :class="{
                  'is-invalid':
                    showError &&
                    (!item.start_age ||
                      item.start_age * 1 < MfEditing.insured.insured_age * 1 ||
                      (index - 1 > -1 &&
                        addPaymentScope.flexiblePrem[index].start_age * 1 <=
                          addPaymentScope.flexiblePrem[index - 1].end_age * 1)),
                }"
              />
              <strong class="mr_2">歲 ~ </strong>
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2 ml_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'end_age')"
                v-model.trim="item.end_age"
                :class="{
                  'is-invalid':
                    showError &&
                    (!item.end_age ||
                      item.end_age * 1 < item.start_age * 1 ||
                      item.end_age * 1 > nowProduct.pol_endage * 1),
                }"
              />
              <strong>歲:</strong>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex mr_10 align-items-center">
              <strong>每年繳費:</strong>
              <input
                ype="tel"
                class="form-control mr_2 ml_2"
                style="width: 7rem"
                :class="{ 'is-invalid': errors.has(`flexiblePrem_${index}`) }"
                :data-vv-name="`flexiblePrem_${index}`"
                v-validate="`required|flexiblePrem`"
                @input="numberHandler(item, 'premium', $event)"
                @blur="numberHandler(item, 'premium', $event)"
                :value="item.premium | formatMethods"
              />元
              <div class="text-red fz_13 ml_5 mr_6" style="width: 14.5rem">
                {{
                  `最低${formatMethods(
                    PRODUCT_FEATURE_DATA.untm_amt_lmt
                  )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}`
                }}
              </div>
              <div
                class="btn btn-default btn-sm px_2 pt_2"
                @click="deletRange('flexiblePrem', index)"
              >
                <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt_10">
          <div
            class="btn btn-default add__button"
            @click="addRange('flexiblePrem')"
          >
            <i class="icon-add_new text-orange i-20 mr_5"></i>
            <div>增加一筆</div>
          </div>
        </div>
      </div>
    </section>
    <FixedBottom>
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <div
            class="btn btn-default px_5 mr_10"
            type="button"
            @click="goback()"
          >
            返回上一頁
          </div>

          <button
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="next()"
          >
            預覽
          </button>
        </div>
      </template>
    </FixedBottom>
  </main>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import Tooltip from "@/desktop/components/ToolTip";
import { Validator } from "vee-validate";
import InsuredInfo from "@/desktop/views/mf/components/InsuredInfo";

import _ from "lodash";

export default {
  mixins: [mf_Mixin],
  components: { FixedBottom, Tooltip, InsuredInfo },
  data() {
    return {
      addPaymentScope: {
        regularFlexiblePrem: [], //定期超額保費
        flexiblePrem: [], //超額保費
        adjAmtFlexible: [], //基本保額
      },
      showError: false,
      adj_amt_limit: [],
    };
  },
  computed: {
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
    PRODUCT_FEATURE_DATA() {
      return this.MfEditing.mc_prod_list[0].FEATURE_DATA;
    },
    is_crm() {
      return this.MfEditing.inputType == "noId" ? "0" : "1";
    },
    amt_formatVal() {
      if (this.PRODUCT_FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.PRODUCT_FEATURE_DATA.amt_unit);
      }
    },
  },
  created() {
    if (!this.nowProduct) {
      this.$router.replace("/mf");
    }
    this.init();
    //已有年齡資料時，直接顯示原本年齡檢核樣式
    this.showError = this.checkHasAgeData();
    this.calculateAdjAmtLimit();
  },

  methods: {
    init() {
      if (this.nowProduct.paymethod && this.nowProduct.paymethod != "{}") {
        //是否有修改過資料
        const isTemp__addPayment =
          this.nowProduct.hasOwnProperty("temp__addPayment");
        if (isTemp__addPayment) {
          this.nowProduct.temp__addPayment !== null
            ? (this.addPaymentScope = _.cloneDeep(
                this.nowProduct.temp__addPayment
              ))
            : (this.addPaymentScope = JSON.parse(this.nowProduct.paymethod));
        } else {
          this.addPaymentScope = JSON.parse(this.nowProduct.paymethod);
        }
      } else if (this.nowProduct.temp__addPayment) {
        this.addPaymentScope = _.cloneDeep(this.nowProduct.temp__addPayment);
      } else {
        this.addPaymentScope.regularFlexiblePrem = [];
        this.addPaymentScope.flexiblePrem = [];
        this.addPaymentScope.adjAmtFlexible = [];
      }
      if (
        this.addPaymentScope.adjAmtFlexible === null ||
        this.addPaymentScope.adjAmtFlexible === undefined
      ) {
        this.$set(this.addPaymentScope, 'adjAmtFlexible', []);
      }
      Validator.extend(`regularFlexiblePrem`, {
        getMessage: "保費金額錯誤",
        validate: (value) => {
          let intValue = parseInt(value.split(",").join(""));
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          return (
            intValue >= this.PRODUCT_FEATURE_DATA.untm_amt_lmt &&
            intValue % incr_unit === 0
          );
        },
      });
      Validator.extend(`flexiblePrem`, {
        getMessage: "保費金額錯誤",
        validate: (value) => {
          let intValue = parseInt(value.split(",").join(""));
          return intValue >= this.PRODUCT_FEATURE_DATA.untm_amt_lmt;
        },
      });
      Validator.extend(`adjAmtFlexible`, {
        getMessage: "保額錯誤",
        validate: (value, { floor, ceil }) => {
          let intValue = parseInt(value.split(",").join(""));
          return intValue >= Number(floor) && intValue <= Number(ceil);
        },
      });
      setTimeout(() => {
        this.registerHanlink();
      }, 500);
    },
    goback() {
      this.$mfNotice(
        " 返回上一頁將不儲存本次編輯內容!",
        () => {
          this.nowProduct.temp__addPayment = null;
          this.$router.push("/mf/create");
        },
        true,
        () => {},
        "確定",
        "<div class='fz_20'>不儲存本次編輯內容請點擊「確定」，若欲儲存請點擊「取消」，並繼續編輯。</div>"
      );
    },
    async next() {
      this.showError = true;
      let data = this.addPaymentScope.adjAmtFlexible;
      let newData = this.calculateEndAges(data);
      this.addPaymentScope.adjAmtFlexible = newData;
      let premiumCheck = await this.$validator.validateAll();
      if (this.checkAgeRange() && this.checkAmtRange() && premiumCheck) {
        this.nowProduct.temp__addPayment = _.cloneDeep(this.addPaymentScope);
        this.$router.push("/mf/create/paymentPreview");
      } else {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      }
    },
    addRange(targetKey) {
      let start_age =
        this.addPaymentScope[targetKey].length == 0
          ? this.MfEditing.insured.insured_age
          : "";
      if (targetKey == "adjAmtFlexible" && start_age != "") {
        start_age = this.MfEditing.insured.insured_age * 1 + 1;
      }
      this.addPaymentScope[targetKey].push({
        start_age: start_age,
        end_age: "",
        premium: "",
      });
    },
    deletRange(targetKey, index) {
      this.addPaymentScope[targetKey].splice(index, 1);
    },
    checkHasAgeData() {
      for (let key in this.addPaymentScope) {
        let dataList = this.addPaymentScope[key];

        if (!Array.isArray(dataList)) continue;

        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].start_age || dataList[i].end_age) {
            return true;
          }
        }
      }

      return false;
    },
    checkAgeRange() {
      let error = () => {
        this.$toast.info({
          title:
            "後面輸入的歲數不可小於(或等於)前面的歲數，並注意需在被保險人年齡與目標保費繳費年齡之間!",
        });
        return false;
      };
      let regularFlexiblePrem = this.addPaymentScope.regularFlexiblePrem;
      let flexiblePrem = this.addPaymentScope.flexiblePrem;
      let adjAmtFlexible = this.addPaymentScope.adjAmtFlexible;
      let insured_age = this.MfEditing.insured.insured_age;
      let pol_period = parseInt(this.PRODUCT_FEATURE_DATA.pol_period, 10) - 1;
      for (let i = 0; i < regularFlexiblePrem.length; i++) {
        if (
          !regularFlexiblePrem[i].start_age ||
          !regularFlexiblePrem[i].end_age ||
          regularFlexiblePrem[i].start_age * 1 < insured_age * 1 ||
          regularFlexiblePrem[i].end_age * 1 > this.nowProduct.pol_endage * 1 ||
          regularFlexiblePrem[i].end_age * 1 <
            regularFlexiblePrem[i].start_age * 1 ||
          (i > 0 &&
            regularFlexiblePrem[i].start_age * 1 <=
              regularFlexiblePrem[i - 1].end_age * 1)
        ) {
          error();
          return false;
        }
      }
      for (let i = 0; i < flexiblePrem.length; i++) {
        if (
          !flexiblePrem[i].start_age ||
          !flexiblePrem[i].end_age ||
          flexiblePrem[i].start_age * 1 < insured_age * 1 ||
          flexiblePrem[i].end_age * 1 > this.nowProduct.pol_endage * 1 ||
          flexiblePrem[i].end_age * 1 < flexiblePrem[i].start_age * 1 ||
          (i > 0 &&
            flexiblePrem[i].start_age * 1 <= flexiblePrem[i - 1].end_age * 1)
        ) {
          error();
          return false;
        }
      }
      for (let i = 0; i < adjAmtFlexible.length; i++) {
        if (
          !adjAmtFlexible[i].start_age ||
          !adjAmtFlexible[i].end_age ||
          adjAmtFlexible[i].start_age * 1 < insured_age * 1 + 1 ||
          adjAmtFlexible[i].end_age * 1 > pol_period ||
          adjAmtFlexible[i].end_age * 1 < adjAmtFlexible[i].start_age * 1 ||
          (i > 0 &&
            adjAmtFlexible[i].start_age * 1 <=
              adjAmtFlexible[i - 1].end_age * 1)
        ) {
          error = () => {
            this.$toast.info({
              title:
                "後面輸入的歲數不可小於(或等於)前面的歲數，並注意需小於調整基本保額最高年齡!",
            });
            return false;
          };
          error();
          return false;
        }
      }
      return true;
    },
    calculateEndAges(data) {
      let MAX_AGE = parseInt(this.PRODUCT_FEATURE_DATA.pol_period, 10) - 1;
      let MIN_AGE = parseInt(this.MfEditing.insured.insured_age, 10);

      if (!Array.isArray(data)) return [];
      let processedData = JSON.parse(JSON.stringify(data));
      for (let i = 0; i < processedData.length; i++) {
        let current = processedData[i];
        current.end_age = current.end_age || "";
        if (i === processedData.length - 1) {
          current.end_age = MAX_AGE.toString();
          break;
        }
        let nextExists = i + 1 < processedData.length;
        let nextItem = nextExists ? processedData[i + 1] : null;
        let nextStart =
          nextItem && nextItem.start_age
            ? parseInt(nextItem.start_age, 10)
            : null;
        if (!nextItem || typeof nextStart !== "number") {
          current.end_age = MAX_AGE.toString();
          break;
        }
        let calculatedEnd = nextStart - 1;
        if (calculatedEnd >= MAX_AGE) {
          current.end_age = MAX_AGE.toString();
          break;
        }
        current.end_age = Math.min(calculatedEnd, MAX_AGE).toString();
        if (current.end_age === MAX_AGE.toString()) {
          break;
        }
      }
      return processedData;
    },
    async calculateAdjAmtLimit() {
      let insured_actage = this.MfEditing.insured.insured_birthday
        ? moment().diff(
            moment(this.MfEditing.insured.insured_birthday),
            "years"
          )
        : this.MfEditing.insured.insured_age;
      let { adj_amt_limit } = await this.$mfAPI.MFB1_0100__getINVAmtLimitRanges(
        {
          prod_id: this.nowProduct.prod_id,
          insured_actage: insured_actage,
          insured_age: this.MfEditing.insured.insured_age,
          insured_gender: this.MfEditing.insured.insured_gender,
          premium: this.nowProduct.pol_premium,
          pay_freq: this.nowProduct.pay_freq,
        }
      );
      this.adj_amt_limit = adj_amt_limit;
    },
    checkAmtRange() {
      //因應後段共用邏輯，此處之premium存放之資料為amt(調整之基本保額)
      let adjAmtFlexible = this.addPaymentScope.adjAmtFlexible;
      return !adjAmtFlexible.some(
        (item) =>
          Number(item.premium) < Number(this.adj_amt_limit.amt_floor) ||
          Number(item.premium) > Number(this.adj_amt_limit.amt_ceil)
      );
    },
  },
  beforeRouteLeave(to, from, next) {
    if (from.path == "/mf/create/addPayment") {
      let reset = () => {
        setTimeout(() => {
          this.$store.commit("reset_MfEditing");
        }, 500);
        next();
      };
      if (to.path == "/mf/create/paymentPreview" || to.path == "/mf/create") {
        next();
      } else {
        this.$mfNotice(
          "本建議書尚未完成，是否確定放棄?",
          () => {
            reset();
          },
          true,
          null,
          "確定放棄",
          "",
          "",
          "繼續輸入"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.addPayMent {
  &__customer {
    display: flex;
    align-items: center;
    font-size: 18px;
    &__role {
      width: 114px;
      font-weight: 700;
    }
    &__name {
      display: flex;
      align-items: center;
    }
  }
  .add__button {
    width: 150px;
    height: 42px;
    border-radius: 4px;
    border: solid 1px #f58818;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #f58818;
    cursor: pointer;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    &__icon {
      padding: 0;
      font-size: 36px;
      color: #f58818;
      line-height: 1;
      font-family: serif;
      font-weight: 700;
    }
  }
}
</style>
